export default __webpack_public_path__ + "static/driver-cloud-de51a0f632769754a524fb52fa5b770a.mp4";